import React, { Fragment } from 'react'
import { DisplayPrice } from 'app/React/Components/Main/DisplayPrice'
import PropTypes from 'prop-types'

export function RenderOption({ option }) {
  return (
    <>
      <div className='config-overview__price'>
        <div>{option.title ?? option.name}</div>
        <div>
          <DisplayPrice option={option}/>
        </div>
      </div>
      {option.description_plain ? (
        <div
          className='config-overview__variant_description'
          dangerouslySetInnerHTML={{ __html: option.description_plain }}
        />
      ) : null}
    </>
  )
}

RenderOption.propTypes = {
  option: PropTypes.any.isRequired
}
